<template>
    <div id="login">

        <div class="form_center">
            <img src="../../assets/image/logo.png" alt="" class="form_logo">
            <div style="margin-top: 60px">
            </div>
            <div class="form_input_item">
                <a-input class="nor_input" v-model="userName">
                    <a-icon slot="prefix" type="user"/>
                </a-input>
            </div>
            <div class="form_input_item">
                <a-input class="nor_input" v-model="password" type="password">
                    <a-icon slot="prefix" type="lock" theme="filled"/>
                </a-input>
            </div>
            <div class="form_input_fix">
                <a-input class="fix_input" v-model="verCode"></a-input>
                <div id="verificationCode" class="verificationCode">
<!--                    <canvas width="100" height="40" id="verifyCanvas"></canvas>-->
                    <img ref="code_img" :src="imgUrl" @click="changeCode(false)">
                </div>
            </div>
            <div class="form_input_arround">
                <a @click.stop="forgetPassword" class="form_internal">Forgot password?</a>
                <a @click.stop="reloadNewPage" class="form_internal">Internal</a>
            </div>
            <div class="form_input_item">
                <a-button @click.stop="loginClick" class="form_login_btn">Sign in</a-button>
            </div>
            <!--            <div v-if="!isShowRegister"-->
            <!--                 class="form_login_btn"-->
            <!--                 @click.stop="gotoInternal()">-->
            <!--                Internal ItCode Login-->
            <!--            </div>-->
            <!--            <div v-if="!isShowRegister"-->
            <!--                 class="form_login_btn"-->
            <!--                 @click.stop="gotoExternal()">-->
            <!--                External Email Login-->
            <!--            </div>-->
            <!--            <div v-if="!isShowRegister" class="form_register_btn">-->
            <!--                No account?-->
            <!--                <span class="register_button" @click.stop="gotoRegisterPage()">Register one</span>-->
            <!--            </div>-->

            <!--            <div v-if="isShowRegister" class="form_input_item">-->
            <!--                <a-input type="text" placeholder="Please input email" v-model="email"/>-->
            <!--            </div>-->

            <!--            <div v-if="isShowRegister" class="form_login_btn" @click.stop="startRegister()">Register</div>-->
            <!--            <div v-if="isShowRegister" class="form_login_btn" @click.stop="gotoRegisterPage()">Cancel</div>-->
        </div>
    </div>
</template>

<script>
    import {getAdfsConfig} from "@/utils/requestFail";
    import {CasConfigKey} from "@/utils/request";
    import {loginAction, getImgUrl, getExternalUrl, getInternalUrl, registerUser} from './loginApiMethod'
    import {getUserInfo} from "../Home/homeApiMethod";
    import modal from 'ant-design-vue/es/modal'
    import {drawCode} from './verificationCode'

    export default {
        name: "login",
        data() {
            return {
                userName: '',
                password: '',
                verCode: '',
                imgUrl: '',
                isShowRegister: false,
                casInternal: '',
                casExternal: '',
                email: '',
            }
        },
        destroyed() {
        },
        components: {
            modal
        },
        created() {
            this.changeCode(true);
            // this.getAllLoginUrl();
        },
        watch: {
            $route: function (newVal) {
                console.log(newVal)
            }
        },
        methods: {
            getAllLoginUrl() {
                getExternalUrl().then(res => {
                    this.casExternal = res['cas'] || '';
                });
                getInternalUrl().then(res => {
                    this.casInternal = res['cas'] || '';
                });
            },
            gotoInternal() {
                if (this.casInternal && this.casInternal.length > 0) {
                    window.location.href = this.casInternal
                } else {

                }
            },
            gotoExternal() {
                if (this.casExternal && this.casExternal.length > 0) {
                    window.location.href = this.casExternal
                }
            },
            gotoRegisterPage() {
                this.isShowRegister = !this.isShowRegister
            },
            startRegister() {
                if (this.email && this.isValidEmail(this.email)) {
                    let userName = this.email.split('@')[0]
                    const param = {
                        userName: userName,
                        email: this.email
                    }
                    registerUser(param).then(res => {
                        let msg = res.message || 'Register Success!';
                        this.$message.success(msg);
                        this.gotoRegisterPage()
                    })
                } else {
                    this.$message.error('The email address entered is illegal');
                }

            },

            async changeCode(isFirst) {
                // let verifyCodeUrl = baseURL + '/' + path.apiName + '/user/auth/code?' + new Date().getTime()
                let verifyCodeUrl = '/user/auth/code?' + new Date().getTime()
                const self = this;
                getImgUrl(verifyCodeUrl).then(res => {
                    self.imgUrl = window.URL.createObjectURL(res)
                })
            },
            loginClick() {
                const param = {
                    username: this.userName,
                    password: this.password,
                    isinner: '0',
                    imageCode: this.verCode,
                };

                this.$store.commit('setDefRouters', [])
                // console.log('param : ', param);
                loginAction(param).then(res => {
                    if (res.errorCode === 200) {
                        this.getUserInfo()
                    } else {
                        const msg = res.errorMsg ? res.errorMsg : 'Request Fail'
                        modal.error({
                            title: 'Error',
                            content: msg,
                            onOk: () => {
                                this.changeCode(false)
                            }
                        })
                    }
                })
            },
            forgetPassword() {
                alert('Dear user,\n\n If you forgot your password, please contact IT Support.\n\nThanks.')
            },
            reloadNewPage() {
                getAdfsConfig().then(res => {
                    sessionStorage.setItem(CasConfigKey, res.cas)
                    window.location.href = res.cas
                })
            },
            getUserInfo() {
                getUserInfo().then(res => {
                    this.$store.dispatch('setUserInfo', res).then(() => {
                        location.reload();
                    })
                }).catch(() => {
                })
            },
            isValidEmail(str) {
                if (str.indexOf('@', 0) === -1 || str.indexOf('.', 0) === -1) {
                    return false
                }
                return true
            }
        }
    }
</script>

<style lang="less" scoped>
  ::-webkit-scrollbar {
    display: none;
  }

  #login {
    margin: 0;
    background: url('../../assets/global.svg') no-repeat bottom center, url('../../assets/background.svg') repeat-x;
    min-height: 100vh;
    position: relative;

    .form_center {
      width: 260px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -130px;
      margin-top: -300px;

      .form_logo {
        width: 100%;
        height: auto;
      }

      .form_input_item {
        margin-top: 20px;
        height: 40px;

        .nor_input {
          background-color: #00000000;
          border: none;
          outline: none;
          box-shadow: none;
          height: 100%;
          width: 100%;
        }
      }

      .form_input_fix {
        margin-top: 20px;
        display: flex;
        height: 40px;
        justify-content: space-between;
        background-color: #fff;
        border: 1px solid #eeeeee;
        .verificationCode{
          width: 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-content: center;
        }
        .fix_input {
          background-color: transparent;
          width: calc(100% - 100px);
          height: 30px;
          margin-top: 5px;
          border: none;
          outline: none;
          box-shadow: none;
        }

        .fix_input:active {
          border: none;
        }
      }

      .form_input_arround {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;

        a {
          color: #2c3e50;
        }
      }


    }
  }

  .form_register_btn {
    margin-top: 5px;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    color: #222222;
    text-align: center;
    line-height: 40px;
  }

  .register_button {
    color: #1a6fc4;
    cursor: pointer;
  }

  .register_button:hover {
    color: #4a148c;
  }

  .form_login_btn {
    margin-top: 20px;
    width: 100%;
    font-size: 14px;
    color: #ffffff;
    font-weight: 500;
    background-color: #1a6fc4;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 2px;
    cursor: pointer;
  }
</style>
